import React, { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { PageLoader } from './PageLoader'
import { AppCommon } from './AppCommon'
import { ErrorBoundary } from '../components/WidgetBuilder/UI/Components/ErrorBoundary'
import { SentryInit } from '../lib/sentry'

const BuilderPage = lazy(() => import('./Pages/BuilderPage'))
const PreviewPage = lazy(() => import('./Pages/PreviewPage'))
const TitanFilesPage = lazy(() => import('./Pages/TitanFilesPage'))

SentryInit('web')

export const routes = (
  <ErrorBoundary name="routes">
    <Suspense fallback={<PageLoader />}>
      <Router>
        <AppCommon>
          <Switch>
            <Route exact path="/project" component={BuilderPage} />
            <Route exact path="/project/:hash" component={BuilderPage} />
            <Route exact path="/fttitanfiles/builder/:username/:hash" component={TitanFilesPage} />
            <Route path="/*" component={PreviewPage} />
          </Switch>
        </AppCommon>
      </Router>
    </Suspense>
  </ErrorBoundary>
)
